export default "__VITE_ASSET__D0fjMfBS__"